import { render } from "./EmptyCardLoading.vue?vue&type=template&id=a2ed4236"
import script from "./EmptyCardLoading.vue?vue&type=script&lang=js"
export * from "./EmptyCardLoading.vue?vue&type=script&lang=js"

import exportComponent from "/builds/playmob1/songreach/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__